<template>
	<li class="item" :class="result.Status.toLowerCase()" tabindex="0">
		

		<span class="name list-item-info hide-desktop">{{result.FirstName}} {{result.LastName}}</span>
		<span class="name-first list-item-info hide-mobile">{{result.FirstName}}</span>
		<span class="name-last list-item-info hide-mobile">{{result.LastName}}</span>
		<span class="email list-item-info">
			<a :href="'mailto:' + result.Email" :title="'Email ' + result.FirstName + result.LastName">{{result.Email}}</a>
		</span>
		<span class="dba list-item-info">{{result.Status}}</span>

		<div class="user-actions list-item-info">
			<div class="current-user" v-if="result.Status !== 'Disabled'">
				<a :href="'/account/edit/' + result.ContactGuid" title="Edit User">
					<span class="icon icon-edit user-action edit-user" ></span>
				</a>

					<span v-on:click="deleteUser()" v-on:keyup.enter="deleteUser()" tabindex="0" class="icon icon-block user-action remove-user" title="Remove User" ></span>

			</div>
			<div class="new-user" v-if="result.Status === 'Disabled'">
				<a :href="'/account/add/kentico-user/' + result.ContactGuid" title="Add User">
					<span class="icon icon-user-plus user-action add-user"></span>
				</a>
			</div>

		</div>
	</li>

</template>


<script>
	import * as Constants from 'constants';
	import vueSmoothScroll from 'vue-smoothscroll';

	export default {
		props: {
			result: {
				type: Object,
				default: () => { }
			},
		},

		data: function () {
			return {

			}
		},
		mounted() {
			document.getElementsByClassName('users-list')[0].classList.remove('loading');
		},
		methods: {
			deleteUser() {

				$('.action-message').slideUp(function () {
					$('.action-message-container').addClass('hidden');
				});
				
				$('.js-wait-loader').show();

				let ajaxLoadTimeout = setTimeout(() => {
					this.results = [];
				}, 1000);

				let fetchUrl = Constants.ENVIRONMENT_API + `user/disable/${this.result.ContactGuid}`;

				fetch(fetchUrl, {
					method: 'DELETE',
					headers: {
						'AuthenticatedUser': window.LMC.authenticatedUser
					}
				})
				.then(response => {
                    if (response.ok) {
						this.$SmoothScroll(0, 500);
						this.result.IsUserInKentico = false;
						$('.js-delete-success-message').parent().removeClass('hidden');
						$('.js-delete-success-message').slideDown();
                        $('.js-wait-loader').hide();

                        this.$emit('setuserfilter', { query: '', isUserPagerCall: false });
                        return Promise.resolve(response);
					}
					else {	
						this.$SmoothScroll(0, 500);
						$('.js-error-message').parent().removeClass('hidden');
						$('.js-error-message').slideDown();
						$('.js-wait-loader').hide();
						return Promise.reject(new Error(error));
					}
				})
				.catch(error => {
					console.log(error);
				});
			},
			getCookie(cname) {
				let name = cname + "=";
				let decodedCookie = decodeURIComponent(document.cookie);
				let ca = decodedCookie.split(';');
				for (var i = 0; i < ca.length; i++) {
					var c = ca[i];
					while (c.charAt(0) === ' ') {
						c = c.substring(1);
					}
					if (c.indexOf(name) === 0) {
						return c.substring(name.length, c.length);
					}
				}
				return "";
			}
		}
	}
</script>